var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagStBarts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0117C24.8366 32.0117 32 24.8483 32 16.0117C32 7.17516 24.8366 0.0117188 16 0.0117188C7.16344 0.0117188 0 7.17516 0 16.0117C0 24.8483 7.16344 32.0117 16 32.0117Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5681 12.8812H23.3043C23.3043 11.9207 22.5257 11.1421 21.5652 11.1421L20.1739 13.9247C20.1739 13.9247 21.658 18.0986 21.6115 18.0986H23.3507C24.3112 18.0986 25.0898 17.32 25.0898 16.3595C26.0503 16.3595 26.8289 15.5809 26.8289 14.6204H26.771C27.7314 14.6203 28.5681 13.8417 28.5681 12.8812Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43188 12.8812H8.69564C8.69564 11.9207 9.47428 11.1421 10.4348 11.1421L11.8261 13.9247C11.8261 13.9247 10.342 18.0986 10.3884 18.0986H8.64929C7.68875 18.0986 6.91018 17.32 6.91018 16.3595C5.94964 16.3595 5.17106 15.5809 5.17106 14.6204H5.22898C4.26845 14.6203 3.43188 13.8417 3.43188 12.8812Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 22.2725V22.9681H10.4348V22.2725H7.65216V25.0551H10.4348V25.7507H21.5652V25.0551H24.3478V22.2725H21.5652Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 11.1419V18.0984C10.4348 22.3583 15.9999 23.6636 15.9999 23.6636C15.9999 23.6636 21.5651 22.3583 21.5651 18.0984V11.1419L15.9999 10.4463L10.4348 11.1419Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 13.9248H21.5652V18.0987H10.4348V13.9248Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7825 7.66379V8.70727L18.0869 9.05512L17.3913 8.35942V6.27246H14.6087V8.35942L13.913 9.05512L13.2173 8.70727V7.66379H10.4348V11.142H21.5652V7.66379H18.7825Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagStBarts);
export default __webpack_public_path__ + "static/media/flag_st_barts.9e5c47380f8b37a7ae6597f5ee7aab43.svg";
export { ForwardRef as ReactComponent };